import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import UserIcon from './icons/userIcon';

import Icon from '../../../../components/Icon';

export const CSSTransitionStyles = styled(CSSTransition)``;

export const SidebarBackdrop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
  background: var(--overlay);
`;

export const SidebarPanel = styled.div`
  overflow: auto;
  width: 240px;
  height: 100%;
  background-color: white;
  box-shadow: 3px 0 6px var(--box-shadow);
  position: relative;
`;

export const SidebarHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 160px;
  background: var(--luft-primary);
`;

export const SidebarLogo = styled.img`
  height: 32px;
`;

export const SidebarNav = styled.nav``;

export const SidebarHr = styled.hr`
  height: 1px;
  border: 0;
  margin: 0 16px;
  background: var(--gray-light);
`;

export const SidebarNavList = styled.ul`
  margin: 0;
  padding: 16px;
  font-size: 16px;
  list-style: none;
`;

export const SidebarNavItem = styled.li`
  margin-top: 8px;
  list-style: none;

  a.Sidebar__nav-link--active {
    color: white;
    background-color: var(--luft-primary);
  }

  &:hover {
    text-decoration: none;
    background: var(--gray-lightest);
  }
`;

const navLinkCommon = css`
  display: block;
  padding: 8px;
  border-radius: 2px;
  font-size: 16px;
  line-height: 20px;
  color: var(--luft-primary);

  /* a styles override */
  text-decoration: none;

  /* button styles override */
  width: 100%;
  border: 0;
  font-family: var(--luft-fonts);
  text-align: left;
  background: transparent;
  cursor: pointer;
`;

export const SidebarNavLink = styled.button`
  ${navLinkCommon};
`;

export const SidebarNavLinkRouter = styled(NavLink)`
  ${navLinkCommon};
`;

export const SidebarNavLinkIcon = styled(Icon)`
  width: 18px;
  margin-right: 8px;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
`;

export const SidebarAppVersion = styled.small`
  display: none;

  @media all and (min-height: 585px) {
    display: block;
    font-size: 12px;
    color: var(--gray-light);

    position: relative;
    bottom: 15px;
    width: 100%;
    text-align: center;
  }
`;

export const SidebarActiveCompany = styled.button`
  background: var(--luft-secondary-darker);
  width: 100%;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  border: 0;
  ${({ isAdmin }) => isAdmin && 'cursor: pointer;'}
`;

export const CompanyAndUserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: start;
  color: white;
  font-family: var(--luft-fonts);

  span:first-child {
    font-size: 16px;
  }

  span:last-child {
    font-size: 12px;
  }
`;

export const CompanyNameStyled = styled.span`
  font-size: 12px;

`;

export const SidebarActiveCompanyIcon = styled(UserIcon)`
  width: 16px;
  height: 20px;
  stroke: white;
  margin: 19px 20px 19px 10px;
`;
